<template>
  <div class="point-marker">
    <!-- Icon marker -->
    <div class="point-marker__icon">
      <img alt="point-marker" src="@/assets/images/point/marker-no-shadow.svg" />
      <div class="point-marker__flag" :style="{ backgroundColor: color }">
        <i class="icon-outline_flag" />
      </div>
    </div>

    <!-- Label di bawah marker -->
    <div class="point-marker__label">
      <McBadge :text="point.name" type="button" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import McBadge from '@/components/McBadge'

export default {
  components: {
    McBadge,
  },
  props: {
    color: {
      type: String,
      default: '#000000',
    },
    number: {
      type: Number,
      default: 1,
    },
    point: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
  },
}
</script>

<style lang="scss" scoped>
.point-marker {
  display: flex;
  flex-direction: column;
  align-items: center; // center horizontal
  text-align: center;

  &__icon {
    position: relative;
    width: 40px;

    img {
      width: 100%;
      display: block;
    }
  }

  &__flag {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;
    background-color: $cyan;

    i {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 20px;
      color: $white;

      &:before {
        color: $white;
      }
    }
  }

  &__label {
    margin-top: 4px;

    // memastikan badge tidak pecah atau overflow
    :deep(.mc-badge) {
      white-space: nowrap;
    }
  }
}
</style>
